import { useRef, useState } from 'react'
import SideMenuItem from '../SideMenuItem/SideMenuItem';
import Quiz from '../Quiz';
import Notes from '../Notes';
import Doubts from '../Doubts';
import InfoButton from '../../../components/Buttons/InfoButton';
import RelatedContent from '../RelatedContent';
import { useNavigate, useParams } from 'react-router-dom';
import { tilebarConstants } from './TilebarConstants';
import { useSelector, useDispatch } from 'react-redux';
import { enrollSkill, getUserActivity } from '../../../redux/actions/userActivity.js';
import { addUserActivity } from '../../../redux/actions/profileDetails';
import Spinner from '../../../components/Spinner';
import { userActivity } from '../../../common/constants';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';
import LessonOverview from '../LessonOverview';
import ContentPlayerAccordian from '../ContentPlayerAccordian';
import { CircularProgressbar, buildStyles } from "react-circular-progressbar"
import Task from '../Task';
import { useEffect } from 'react';
import { getQuizActivity } from '../../../redux/actions/quiz';
import Milestones from '../Milestones';
import SettingsTab from '../Settings';
import { toast } from 'react-toastify';
import '../ContentPlayer/ContentPlayer.css'
import './index.css'
import { getEnrolledMSkills } from '../../../redux/actions/skills.js';

export default function TileBar({
  mskillData,
  skillData,
  mSkillProgress,
  quizRef,
  setProgress,
  watchedLessons,
  setWatchedLessons,
  tilebarItem,
  setTilebarItem,
  getlocalTimeStringFromSeconds,
  playerDetails,
  videoProgressTime,
  playerRef,
  isUserEnrolled,
  getSecondsFromLocalString,
  ToggleBtn,
  mainRef,
  skillProgress,
  setDiscountForLessonAndComplete,
  discountForLessonAndComplete,
  tasks,
  handleTaskChange,
  curTask,
  taskAction,
  setTaskAction,
  scrollRef,
  mskillProgressObject,
  setMskillProgressObject,
  unlockedCourses,
  isBeta
}) {
  // const navigate = useNavigate()
  const [enrollSpinner, setEnrollSpinner] = useState(false);
  // const [skillProgress, setSkillProgress] = useState(skillData?.progress)

  const { skill_slug, mskill_slug, contentId } = useParams();
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const email = useSelector((store) => store?.profileDetails?.email);
  const dispatch = useDispatch();
  const user_token = useSelector((store) => store?.authentication?.user_token);
  const oneDayScrollRef = useRef();
  const is_activation = useSelector(store=>store?.userActivity?.is_activation);
  const [tileConstants , setTileConstants] = useState(tilebarConstants);
  const [filterState , setFilterState] = useState({data : tileConstants});
  const [quizActivity , setQuizActivity] = useState([]);
  const [mskillEnrolled , setMskillEnrolled] = useState(null);
  const navigate = useNavigate();

  const userEnrollHandler = async (mskill_slug = 'default') => {
    setEnrollSpinner(true);
    await dispatch(enrollSkill(skill_slug, mskill_slug, user_id));
    // dispatch(addUserActivity(user_id, userActivity.COURSE_ENROLLED, '', false, skill_slug));
    await dispatch(
      getUserActivity(user_id, (successObj) => {
        setEnrollSpinner(false);
      })
    );
  };

  const handleEnrollSkillClick = (e) => {
    Mixpanel.track(Constants.Mixpanel.SKILL_ENROLLED, {
      distinct_id: email,
    });
    userEnrollHandler(mskill_slug);
  };

  // console.log(mSkillProgress)
   useEffect(()=>{
    dispatch(getEnrolledMSkills(user_id, skillData?.['skill_slug'] , (successObj)=>{setMskillEnrolled(successObj?.['mskill_enrolled'])}, (errorObj)=>{
    }))


   },[user_id])
 
  useEffect(() => {

    if(isBeta == true && mskillEnrolled!==null ){
      console.log('wed' , unlockedCourses, skillData)
      if(unlockedCourses?.includes(skillData['skill-name'])){
        window.location.href = `https://personalise.learntube.ai/welcome?email=${email}&skill_name=${encodeURIComponent(skillData['skill-name'])}`;
      }
      else if(mskillEnrolled?.some(obj => obj?.skill_slug === skillData?.skill_slug)){
        if(contentId){
          dispatch(getQuizActivity(user_id, contentId, successObj => {
            setQuizActivity(successObj);
            
          },
          (err) => {
            toast.error(err);
          }))
  
      }
      }
      else{
        navigate(`/${skillData?.['course_slug']}/${skill_slug}`, { replace: true });
      }
    }
    else{
      if(contentId){
        dispatch(getQuizActivity(user_id, contentId, successObj => {
          setQuizActivity(successObj);
          
        },
        (err) => {
          toast.error(err);
        }))

    }
    }


  }, [mskill_slug, contentId,tilebarItem,isBeta,unlockedCourses,mskillEnrolled,skillData])
  

  useEffect(()=>{
    
      setTimeout(() => {
        if(scrollRef?.current){
          scrollRef?.current?.scrollIntoView()
        }
      }, 1000)

  }, [mSkillProgress])

  
  useEffect(()=>{
    console.log(curTask,'curTask');
    if(curTask){
      setFilterState((prev)=> ({...prev , data : tileConstants?.filter((item)=> item?.tilebarItemSetter === 'quiz')}));

    }
    else{
      if(is_activation){
      setFilterState((prev)=> ({...prev , data : tileConstants?.filter((item)=> item?.show_in_activation_phase === true)}));
      }
      else{
      setFilterState( (prev)=> ({...prev , data : tileConstants?.filter((item)=> item?.show_in_non_activation_phase === true)}))
      }
    }
  },[curTask])

  useEffect(()=>{
    if(is_activation){
      setFilterState((prev)=> ({...prev , data : tileConstants?.filter((item)=> item?.show_in_activation_phase === true)}));
      }
      else{
      setFilterState( (prev)=> ({...prev , data : tileConstants?.filter((item)=> item?.show_in_non_activation_phase === true)}))
      }
  },[is_activation])
  
  
  
  console.log(filterState,'filter');
  return (
    <>
      <div className="reactour-tilebar flex w-full flex-row items-center justify-start overflow-x-auto border-b-2  md:w-5/6" ref={scrollRef}>
        {filterState?.data &&
          filterState?.data.map((item) => (
            <button
              className={`mx-1 px-2 relative py-2 text-sm sm:text-lg md:px-4 ${item.hidden && 'md:hidden'
                } ${item.tileName === 'Next' && {/*'reactour-sidebar-next'*/}} ${tilebarItem === item.tilebarItemSetter
                  ? 'border-b-4 border-b-cn_green font-bold text-cn_green'
                  : 'text hover:bg-slate-100'
                }`}
              onClick={(e) => {
                setTilebarItem(item.tilebarItemSetter);
                let tileBarType = '';
                switch (item.tilebarItemSetter) {
                  case 'notes':
                    tileBarType = 'NOTES_CLICK';
                    break;
                  case 'doubts':
                    tileBarType = 'DOUBTS_CLICK';
                    break;
                  case 'related':
                    tileBarType = 'RELATED_CLICK';
                    break;
                  default:
                    break;
                }
                Mixpanel.track(Constants.Mixpanel[tileBarType], {
                  distinct_id: email,
                });
              }}
              key={item.id}
            // style={{boxShadow:'0px 2px 10px rgba(0, 0, 0, 0.18)'}}
            >
              {item.tileName}
              {(item?.tilebarItemSetter ==="notes" || item?.tilebarItemSetter==="doubts") && <div className='text-[#1CA571] absolute right-0 top-0 lobster-regular'>x</div>}
            </button>
          ))}
      </div>
      <div
        className={`mb-4 flex w-full flex-col items-center justify-start p-2  ${!curTask ? 'md:w-5/6' : 'md:w-full'
          }`}
      >
        {tilebarItem === 'next' && (
          <div className="w-full">
            <div
              className="flex items-center justify-between rounded p-2 px-4 tilebar-box-shadow "
            >
              <div>
                <small className="text-xs font-semibold text-gray-300">
                  {skillData && skillData['course-name']} &gt;
                </small>
                <p className="font-bold">
                  {skillData && skillData['skill-name']}
                </p>
              </div>
              <div className="h-11 w-11 font-bold">
                <CircularProgressbar
                  value={skillProgress}
                  text={`${skillProgress ? skillProgress : 0}%`}
                  strokeWidth={12}
                  styles={buildStyles({
                    textSize: '25px',
                    pathTransitionDuration: 0.5,
                    // Colors
                    pathColor: `#0BC128`,
                    textColor: '#000',
                    trailColor: '#BFFFC9',
                  })}
                />
              </div>
            </div>
            {mskillData &&
              mskillData?.map((mskill) => (
                <ContentPlayerAccordian
                  title={mskill['mSkill-name']}
                  id={mskill.mskill_slug}
                  mskill={mskill}
                  progress={mSkillProgress}
                >
                  <ul>
                    {mskill['lessons_of_mskill'].map((item) => (
                      <SideMenuItem
                        content={item}
                        active={item.id === playerDetails?.id}
                        key={item.id}
                        tilebarItem={tilebarItem}
                        setTilebarItem={setTilebarItem}
                        setWatchedLessons={setWatchedLessons}
                        watchedLessons={watchedLessons}
                        quizRef={quizRef}
                      />
                    ))}

                    {tasks
                      .filter((val) => val?.mskill_slug === mskill?.mskill_slug)
                      .map((item, id) => (
                        <SideMenuItem
                          // content={item}
                          active={item.id === curTask?.id}
                          key={item.id}
                          // tilebarItem={tilebarItem}
                          setTilebarItem={setTilebarItem}
                          // setWatchedLessons={setWatchedLessons}
                          // watchedLessons={watchedLessons}
                          quizRef={quizRef}
                          // sidebarRef={sidebarRef}
                          handleTaskChange={() => handleTaskChange(item)}
                          task={item}
                          isTask
                        />
                      ))}
                  </ul>
                </ContentPlayerAccordian>
              ))}
          </div>
        )}
        {tilebarItem === 'quiz' && curTask && (
          <Task
            task={curTask}
            mskill_slug={mskill_slug}
            circularProgressbar={() => (
              <div className="h-11 w-11 font-bold">
                <CircularProgressbar
                  value={skillProgress}
                  text={`${skillProgress ? skillProgress : 0}%`}
                  strokeWidth={12}
                  styles={buildStyles({
                    textSize: '25px',
                    pathTransitionDuration: 0.5,
                    // Colors
                    pathColor: `#0BC128`,
                    textColor: '#000',
                    trailColor: '#BFFFC9',
                  })}

                />
              </div>
            )}
            taskAction={taskAction}
            setTaskAction={setTaskAction}
          // skillName={skillData['skill-name']}
          // mskillName={
          //   mskillData.find((i) => i.mskill_slug === mskill_slug)?.[
          //     'mSkill-name'
          //   ]
          // }
          />
        )}
        {tilebarItem === 'quiz' &&
          !curTask &&
          (user_token ? (
            <div className="-z-1 mb-1 w-full" ref={quizRef}>
              <Quiz
                lessonId={playerDetails?.id}
                mskill_slug={mskill_slug}
                setProgress={setProgress}
                setWatchedLessons={setWatchedLessons}
                mSkillProgress={mSkillProgress}
                ToggleBtn={ToggleBtn}
                isUserEnrolled={isUserEnrolled}
                mainRef={mainRef}
                mskillData={mskillData}
                skillProgress={skillProgress}
                setDiscountForLessonAndComplete={
                  setDiscountForLessonAndComplete
                }
                discountForLessonAndComplete={discountForLessonAndComplete}
                oneDayScrollRef={oneDayScrollRef}
                quizActivity={quizActivity}
                mskillProgressObject={mskillProgressObject}
                setmSKillProgressObject={setMskillProgressObject}
              />
            </div>
          ) : (
            <Quiz
              skillProgress={skillProgress}
              lessonId={playerDetails?.id}
              setProgress={setProgress}
              mSkillProgress={mSkillProgress}
              setWatchedLessons={setWatchedLessons}
              ToggleBtn={ToggleBtn}
              mainRef={mainRef}
              mskillData={mskillData}
              setDiscountForLessonAndComplete={setDiscountForLessonAndComplete}
              discountForLessonAndComplete={discountForLessonAndComplete}
              oneDayScrollRef={oneDayScrollRef}
              quizRef={quizRef}
              quizActivity={quizActivity}
              mskillProgressObject={mskillProgressObject}
              setmSKillProgressObject={setMskillProgressObject}
            />
          ))}
        {tilebarItem === 'overview' && (
          <LessonOverview
            playerDetails={playerDetails}
            mSkillProgress={mSkillProgress}
            skillData={skillData}
          />
        )}
        {tilebarItem === 'notes' &&
          (user_token ? (
            isUserEnrolled ? (
              <Notes
              videoProgressTime={videoProgressTime}
              playerRef={playerRef}
              getSecondsFromLocalString={getSecondsFromLocalString}
              getlocalTimeStringFromSeconds={getlocalTimeStringFromSeconds}
              lesson_id={playerDetails?.id}
            />
            ) : (
              <div className="my-8">
                <InfoButton
                  buttonText={'Enroll The Skill To View'}
                  onClick={handleEnrollSkillClick}
                />
              </div>
            )
          ) : (
            <Notes />
          ))
           }
        {tilebarItem === 'doubts' &&
          (user_token ? (
            isUserEnrolled ? (
              <Doubts />
            ) : (
              <div className="my-8">
                <InfoButton
                  buttonText={'Enroll The Skill To View'}
                  onClick={handleEnrollSkillClick}
                />
              </div>
            )
          ) : (
            <Doubts />
          ))}
        {tilebarItem === 'related' &&
          (user_token ? (
            isUserEnrolled ? (
              <RelatedContent playerDetails={playerDetails} />
            ) : (
              <div className="my-8">
                <InfoButton
                  buttonText={'Enroll The Skill To View'}
                  onClick={handleEnrollSkillClick}
                />
              </div>
            )
          ) : (
            <RelatedContent playerDetails={playerDetails} />
          ))}

        {tilebarItem === 'milestones' && (
          <Milestones/>
        )}

        {
          tilebarItem === 'settings'  && (
            <SettingsTab skillData={skillData} setTilebarItem={setTilebarItem}/>
          )
        }
      </div>
    </>
  );
}
